import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import * as styles from './index.scss'
import {TabBar} from 'antd-mobile';
import HomeImg from '@assets/img/home.png'
import HomeSelectedImg from '@assets/img/home_selected.png'
import MeImg from '@assets/img/me.png'
import MeSelectedImg from '@assets/img/me_selected.png'
import intl from '@utils/intl';

const withTabbar = (WrapperComponent) => {
    return class extends ComponentExt<any> {
        constructor(props) {
            super(props)
        }

        render() {
            const {location} = this.props
            return (
                <div>
                    <div className={styles.componentWrapper}>
                        <WrapperComponent {...this.props} />
                    </div>

                    <div className={styles.tabbarWrapper}>
                        <TabBar
                            unselectedTintColor="#949494"
                            tintColor="#EB6A1A"
                            barTintColor="white"
                            noRenderContent={true}
                        >
                            <TabBar.Item
                                title={intl.formatMessage({id: 'tab.text.home'})}
                                key="home"
                                icon={<img src={HomeImg} className={styles.tabbarIcon}/>}
                                selectedIcon={<img src={HomeSelectedImg} className={styles.tabbarIcon}/>}
                                selected={location.pathname === '/global/home'}
                                onPress={() => this.goToPath('/global/home')}
                            />
                            <TabBar.Item
                                title={intl.formatMessage({id: 'tab.text.me'})}
                                key="mine"
                                icon={<img src={MeImg} className={styles.tabbarIcon}/>}
                                selectedIcon={<img src={MeSelectedImg} className={styles.tabbarIcon}/>}
                                selected={location.pathname === '/global/me'}
                                onPress={() => this.goToPath('/global/me')}
                            />
                        </TabBar>
                    </div>
                </div>
            )
        }
    }
}
export default withTabbar
